module.exports = __webpack_public_path__ + "img/photoAlbum4.bc0e5996.jpg";